import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from 'gw-digital-auth-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import React, { useCallback, useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { InputField, CheckboxField, DropdownSelectField } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import {ViewModelServiceContext} from 'gw-portals-viewmodel-react'
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useValidation } from 'gw-portals-validation-react';

import metadata from './PackageDetailsPage.metadata.json5';
import messages from './PackageDetailsPage.messages';
import styles from './PackageDetailsPage.module.scss';

function PackageDetailsPage(props) {
    const translator = useContext(TranslatorContext);
    const { wizardData: submissionVM, updateWizardData , additionalWizardData, updateAdditionalWizardData} = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const [isPageInitialized, setPageInitialized] = useState(false);
    const { isComponentValid, initialValidation, onValidate,registerComponentValidation } = useValidation('PackageDetailsPage');
    const { authHeader } = useAuthentication();

    const isDetailsComponentValid = useCallback(() => {
        if(submissionVM.lobData.homeowners.allCoverables.value.length <= 0){
            addPackageItem();
            return false;
        }
        if (
            (submissionVM.lobData.homeowners.allCoverables.value.filter((c) => {
                return !c.coveragePart || !c.coverageForm}).length > 0)
        ) {
            return false;
        }
        return true;
    }, [submissionVM]);

    useEffect(() => {
        setPageInitialized(true);
        registerComponentValidation(isDetailsComponentValid);
        // The above action only need to run once when the page is mounted
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [registerComponentValidation, isDetailsComponentValid]);

    const onValueChange = useCallback((value, item, prop) => {
        const index = submissionVM.lobData.homeowners.allCoverables.value.indexOf(item.value);
        const path = `lobData.homeowners.allCoverables.children.${index}.${prop.dataPath}`;
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        if(prop.dataPath === 'isPrimary') {
            newSubmissionVM.lobData.homeowners.allCoverables.children.forEach(element => {
                if(element._accessorCode != item._accessorCode) {
                    _.set(element, 'isPrimary', false);
                }
            });
        }
        updateWizardData(newSubmissionVM);
        }, [submissionVM]
    );

    const deletePackage = (event, index) => {
        if(submissionVM.lobData.homeowners.allCoverables.value[index].isNew){
            submissionVM.lobData.homeowners.allCoverables.value.splice(index, 1);        }
        else{
            submissionVM.lobData.homeowners.allCoverables.value[index].isDelete = true;  
            _.set(submissionVM, `lobData.homeowners.allCoverables.children[${index}].isHoValidationRequired.value`,false);          
            _.set(submissionVM, `lobData.homeowners.allCoverables.children[${index}].omiaDetail.isValidationRequired.value`,false);         
        }
        const newSubmissionVM = viewModelService.clone(submissionVM);
        updateWizardData(newSubmissionVM);
        
    }

    const getDataTableCell = (item, index, props) => {
        const path = props.path;
        const value = item[path].value;
        if (path == 'dwellingCounter') {
            return (
                <InputField
                    dataType="string"
                    id={index + path}
                    onValueChange={onValueChange}
                    model={item}
                    dataPath={path}
                    value={value}
                    readOnly={true}
                    showRequired={true}
                />
            )
        }
        else if (path == 'isPrimary' ) {

            return (
                <CheckboxField
                    id={index + path}
                    onValueChange={onValueChange}
                    model={item}
                    dataPath={path}
                    value={value}
                    
                />
            )
        }
        else if (path == 'coveragePart' || path == 'coverageForm') {
            const availableValues = _.get(item, `${path}.aspects.availableValues`)
                .map((i) => {
                    const name = translator({ id: i.name });
                    return { code: i.code, name: name }
                });
               const readOnly = path == 'coveragePart' ? item.coveragePart.value :  path == 'coverageForm' ? item.coverageForm.value :   false;
               return (
                <DropdownSelectField
                    className={styles.coverageForm}
                    id={index + path}
                    onValueChange={onValueChange}
                    dataType="string"
                    model={item}
                    dataPath={path}
                    value={value}
                    availableValues={availableValues}
                    readOnly={readOnly}
                    searchable={true}
                    //disabled={disabled}
                />
            )
        }       

    };

    const addPackageItem = () => {
      
        const packageItems = _.get(submissionVM,'lobData.homeowners.allCoverables');
        packageItems.value = packageItems.value || [];
        const { _xCenter, _dtoName } = packageItems;
        const additionalVM = viewModelService.create({
            isNew: true,
            isHoValidationRequired: true
        }, _xCenter, _dtoName);
        // additionalVM.coverageForm = "standard_ey";
        // additionalVM.coveragePart="homeowners_ey";
        packageItems.pushElement(additionalVM)
        updateWizardData(submissionVM);
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left'
        },
        addPackage:{
            onClick: addPackageItem
        },
        packageDataTable: {
            data: submissionVM.lobData.homeowners.allCoverables.children.filter((c)=>{return !c.isDelete.value})
        },
        deletePackage:{
            disabled: submissionVM.lobData.homeowners.allCoverables.children.length === 1
        }
    };

    const onNext = useCallback(async () => {
        const packageInfo = [];
        _.each(submissionVM.lobData.homeowners.allCoverables.value, (item, index)=>{
            if(!item.isDelete){
                packageInfo.push(item.isNew)
            }
        });
        _.each(submissionVM.lobData.homeowners.allCoverables.children, (item) => {
            item.isHoValidationRequired.value = false
            if( item.omiaDetail.isValidationRequired) {
                item.omiaDetail.isValidationRequired.value=false
            }
        });
        _.unset(submissionVM.value, 'bindData');       
        submissionVM.value = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );
        let _item = {}
         _.each(submissionVM.lobData.homeowners.allCoverables.value, (item, index)=>{
            _item[item.publicID] = !!(additionalWizardData && additionalWizardData.packageInfoDetails && additionalWizardData.packageInfoDetails[item.publicID]) || packageInfo[index];
            return _item;
        });
        let _additionalWizardData = _.clone(additionalWizardData);
        _additionalWizardData['packageInfoDetails'] = _item;
        updateAdditionalWizardData(_additionalWizardData);

        return submissionVM;
    }, [submissionVM, LoadSaveService, authHeader, additionalWizardData, updateAdditionalWizardData]);

    const resolvers = {
        resolveCallbackMap: {
            getDataTableCell: getDataTableCell,
            deletePackage: deletePackage
        }
    };

    if (!isPageInitialized) {
        return null;
    }


    return (
        <WizardPage onNext={onNext} disableNext={!isComponentValid} skipWhen={initialValidation}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

PackageDetailsPage.propTypes = wizardProps;
export default PackageDetailsPage;
